"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'canto',
    client_id: '07-tendermint-10',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'carbon',
    client_id: '07-tendermint-40',
    connection_id: 'connection-23'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-18',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-6',
    connection_id: 'connection-5'
  },
  chain_2: {
    chain_name: 'cosmoshub',
    client_id: '07-tendermint-765',
    connection_id: 'connection-554'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-342',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-11',
    connection_id: 'connection-10'
  },
  chain_2: {
    chain_name: 'evmos',
    client_id: '07-tendermint-73',
    connection_id: 'connection-29'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-6',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-23',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-53',
    connection_id: 'connection-30'
  },
  chain_2: {
    chain_name: 'irisnet',
    client_id: '07-tendermint-151',
    connection_id: 'connection-114'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-28',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-68',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-16',
    connection_id: 'connection-13'
  },
  chain_2: {
    chain_name: 'kujira',
    client_id: '07-tendermint-60',
    connection_id: 'connection-40'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-9',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-46',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-3',
    connection_id: 'connection-1'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-1808',
    connection_id: 'connection-1412'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-188',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'osmosis'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-36',
    connection_id: 'connection-19'
  },
  chain_2: {
    chain_name: 'stargaze',
    client_id: '07-tendermint-224',
    connection_id: 'connection-158'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-15',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-123',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-13',
    connection_id: 'connection-12'
  },
  chain_2: {
    chain_name: 'stride',
    client_id: '07-tendermint-40',
    connection_id: 'connection-27'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-8',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-47',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'carbon',
    client_id: '07-tendermint-33',
    connection_id: 'connection-16'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-66',
    connection_id: 'connection-54'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-12',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-36',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'demex'
    }
  }, {
    chain_1: {
      channel_id: 'channel-16',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-41',
      port_id: 'wasm.terra1e0mrzy8077druuu42vs0hu7ugguade0cj65dgtauyaw4gsl4kv0qtdf2au'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;